<template>
  <div class="dashboard-layout">
    <!-- Header -->
    <DashboardHeader @toggle-sidebar="handleSidebarToggle" />

    <div class="dashboard-content">
      <!-- Sidebar -->
      <DashboardSidebar :is_sidebar_visible="isSidebarVisible" />

      <!-- Main Content -->
      <main class="main-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import DashboardHeader from '@/components/DashboardHeader.vue'
import DashboardSidebar from '@/components/DashboardSidebar.vue'

export default {
  name: 'DashboardView',
  components: {
    DashboardHeader,
    DashboardSidebar
  },
  data() {
    return {
      isSidebarVisible: true,
    };
  },
  methods: {
    handleSidebarToggle() {
      this.isSidebarVisible = !this.isSidebarVisible;
    },
  },
}
</script>

<style scoped>
.dashboard-layout {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.dashboard-content {
  display: flex;
  min-height: calc(100vh - 60px);
}

.main-content {
  flex: 1;
  padding: 20px;
  margin-left: 250px;
  transition: margin-left 0.3s ease;
  background-image: url('/public/images/rr-bg-logo_2.png');
  background-repeat: no-repeat;
  background-position: bottom 2% right 2%;
  background-attachment: fixed;
  background-size: 150px;
  position: relative;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    padding: 15px;
  }
}
</style>